import { createAppAsyncThunk } from "appThunk";
import { cubeLoad } from "modules/helpers/cube/cubeSlice";

import { Store } from "modules/customer/insights/portfolioNew/store";
import { logError } from "modules/helpers/logger/loggerSlice";
import { Query, ResultSet } from "@cubejs-client/core";

export class RetailZoneCells {
    public readonly retailZoneId: string;
    public readonly cellId: string;

    constructor(
        retailZoneId: string,
        cellId: string,
    ) {
        this.retailZoneId = retailZoneId;
        this.cellId = cellId;
    }
}

export const loadRetailZoneCells = createAppAsyncThunk<
    RetailZoneCells[],
    { selectedStore?: Store }
>(
    "customer/insights/portfolioNew/loadRetailZoneCells",
    async ({ selectedStore }, thunkAPI) => {
        try {
            if (!selectedStore) {
                return [];
            }

            // ToDo: Filter directly on store's RzID once available
            const query: Query = {
                dimensions: [
                    "RetailZoneCells.RzIntId",
                    "PetalCells.L10IntId",
                ],
                filters: [{
                    member: "Mapping_RC_RZ.RetailCentreID",
                    operator: "equals",
                    values: [String(selectedStore.retailCentreID)]
                }]
            };

            const resultSet = await thunkAPI.dispatch(cubeLoad(query)) as unknown as ResultSet<any>;
            return resultSet.rawData().map(row =>
                new RetailZoneCells(
                    row["RetailZoneCells.RzIntId"],
                    row["PetalCells.L10IntId"],
                )
            );
        } catch (error) {
            thunkAPI.dispatch(logError("Error loading retail zone cells."));
            return thunkAPI.rejectWithValue(null);
        }
    }
);
